import { getShortcutPrefix } from '../../../../UniversalSearch.utils';

export const SHORTCUT_PREFIX = getShortcutPrefix();
